export default "__VITE_ASSET__CXiW_jMa__"